module.exports = __webpack_public_path__ + "img/check_in.9ca7b68d.svg";